import type { ReactNode } from 'react'
import { cn } from '@/internationalization/cn'

export interface CardProps {
  children: ReactNode
  className?: string
  /** Removes the border+background — for a card that sits on a coloured panel. */
  bare?: boolean
  as?: 'div' | 'section' | 'article' | 'li'
}

export function Card({ children, className, bare, as: Tag = 'div' }: CardProps) {
  return (
    <Tag className={cn(!bare && 'sb-panel', 'overflow-hidden', className)}>{children}</Tag>
  )
}

export function CardHeader({
  title,
  description,
  action,
  className,
}: {
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex items-start justify-between gap-3 border-b border-border px-4 py-3', className)}>
      <div className="min-w-0">
        <h3 className="truncate text-md font-semibold text-fg">{title}</h3>
        {description && <p className="mt-0.5 text-sm text-fg-muted">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  )
}

export function CardBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('px-4 py-3', className)}>{children}</div>
}

export function CardFooter({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('flex items-center justify-end gap-2 border-t border-border bg-surface-muted/60 px-4 py-3', className)}>
      {children}
    </div>
  )
}
